<template>
  <div class="forbidden pa-4">
    <img
      src="@/flit2go-web-core/assets/permission_error.svg"
      class="forbidden__image"
      alt="error"
    />
    <span class="forbidden__title my-2">{{ $t("common.ops") }}</span>
    <span class="forbidden__text my-2">{{
      $t("common.noPermissionsToAccess")
    }}</span>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { OWNERS_HOME } from "@/modules/Owners/routesInterface";

export default {
  name: "Forbidden",
  computed: {
    ...mapState(["auth"]),
  },
  destroyed() {
    this.$store.commit("auth/SET_LAST_ROUTE_VISITED", "");
  },
  methods: {
    redirectToLastPage() {
      if (this.auth.lastRouteVisited && this.auth.lastRouteVisited.length > 0) {
        this.$router.push(this.auth.lastRouteVisited);
      } else {
        this.$router.push(OWNERS_HOME);
      }
    },
  },
};
</script>

<style lang="scss">
.forbidden {
  height: calc(100vh - 60px);
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow-y: auto;

  &__image {
    height: 300px;
    width: 300px;
  }

  @media (max-width: 600px) {
    &__image {
      height: 200px;
      width: 200px;
    }
  }

  &__title {
    font-size: 4rem;
    font-weight: bold;
    text-align: center;
  }

  &__text {
    font-size: 2rem;
    text-align: center;
  }
}
</style>
